export default __webpack_public_path__ + "static/media/apply-leave-disabled.1b81cc06.svg";